import { h, Component } from 'preact';
import { trackingProvider, DIMENSION } from '@cube/track';
import { TaboolaJs } from '../../taboola-js';

export const canRender = () => true;
export const getLink = ({ uri }) => uri;

@trackingProvider({
	[DIMENSION.componentpath]: 'TaboolaJs.Sponsored'
})
export class Card extends Component {

	render({ variant, slideNumber }) {

		let config = {};

		if ('P25-DCC-A' === variant) {
			let id = `taboola-dcc-slide${slideNumber}-js-redesign`;
			config = {
				taboolaJsParams: {
					mode: 'thumbnails-dcc-v5',
					container: id,
					placement: `dcc-slide${slideNumber}-js-redesign`,
					target_type: 'mix'
				},
				id
			};
		}
		else if ('P23-DCC-A' === variant) {
			let id = `taboola-dcc-slide${slideNumber}-js-v3`;
			config = {
				taboolaJsParams: {
					mode: 'thumbnails-dcc-v3',
					container: id,
					placement: `dcc-slide${slideNumber}-js-v3`,
					target_type: 'mix'
				},
				id
			};
		}
		else {
			let id = `taboola-dcc-${slideNumber}`;
			config = {
				taboolaJsParams: {
					mode: 'thumbnails-r',
					container: id,
					placement: `dcc-slide${slideNumber}-js-v2`,
					target_type: 'mix'
				},
				id
			};
		}

		return 	(
			<TaboolaJs {...config} qeId="dcc-taboola-card" />
		);
	}
}

const Taboola = {
	canRender,
	getLink,
	Card
};
export default Taboola;
